import React from 'react';
import PropTypes, { shape } from 'prop-types';
import { params } from '@thd-nucleus/data-sources';
import {
  bool as boolType,
  shape as shapeType,
  string as stringType
} from '@thd-nucleus/data-sources/react/dataModel/prop-types';
import { getShippingTemplate } from '../helpers/shipping-helper';
import { productShape } from '../helpers/pod-fulfillment-utils';
import { dataModel } from '../../components/dataModel';

export const FulfillmentPodShipping = ({ product }) => {
  const ShippingComponent = getShippingTemplate({ product });
  if (!ShippingComponent) {
    return null;
  }

  return (
    <ShippingComponent product={product} />
  );
};

FulfillmentPodShipping.propTypes = {
  product: PropTypes.shape({ productShape }).isRequired,
};

FulfillmentPodShipping.dataModel = {
  product: params({ itemId: stringType().isRequired() }).shape({
    itemId: stringType(),
    info: shapeType({
      isLiveGoodsProduct: boolType()
    }),
    fulfillment: dataModel.clientOnlyProduct.fulfillment
  })
};
